import { useLojinhaContext } from '@lojinha/context';
import { ChatBubble } from '@lojinha/design-system/src/icons';
import { testId } from '@lojinha/helpers';
import React from 'react';
import styled from 'styled-components';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
import { theme } from '../../theme';
import { Box } from '../Box';
import { Card } from '../Card';
import { Spinner } from '../Spinner';
import { Stack } from '../Stack';
import { Text } from '../Text';
const CardWrapper = styled.button `
  bottom: ${theme.space.x16};
  right: ${theme.space.x16};
  background-color: ${theme.colors.white};
  border: none;
  border-radius: ${theme.space.x8};

  &:hover,
  &:active,
  &:focus {
    box-shadow: ${theme.shadows.gray16};
  }

  ${tabNavigationStyle};
`;
export const ChatButton = ({ onOpenChatRequest, chatLoading, text, ariaLabel, }) => {
    const { isChatOpen } = useLojinhaContext();
    if (isChatOpen)
        return null;
    return (React.createElement(CardWrapper, { "aria-label": ariaLabel, onClick: onOpenChatRequest, ...testId('chat-button') },
        React.createElement(Card, { padding: "x13" },
            React.createElement(Stack, { layout: "horizontal", alignItems: "center", margin: "x8" },
                React.createElement(Box, { width: theme.space.x24, height: theme.space.x24, htmlAttrs: {
                        style: { position: 'relative' },
                    } }, chatLoading ? (React.createElement(Spinner, { color: "success", top: theme.space.x2, right: theme.space.x4 })) : (React.createElement(ChatBubble, null))),
                React.createElement(Box, { display: ['none', 'flex'] },
                    React.createElement(Text, { isBold: true, color: "success", textTransform: "uppercase", textSize: "x1" }, text))))));
};
//# sourceMappingURL=index.js.map